<template>
          <div class="time-rem">
            <svg viewBox="0 0 160 160" :width="width || 160" :height="height || 160">
              <circle cx="80" cy="80" r="78" style="stroke: #ccc; stroke-width:4; fill: transparent" />
              <circle cx="80" cy="80" r="78" style="stroke: #457371; stroke-width:4; fill: transparent" v-if="expiryPeriodPercent==100" />
              <path v-else style="stroke:#457371;stroke-width:4; fill: transparent" :d="'M 80 2 A 78 78 0 '+(expiryPeriodPercent>50?'1':'0')+' 1 '+(80+Math.cos((90-expiryPeriodPercent*3.6)/180*3.14159265)*78)+' '+(80-Math.sin((90-expiryPeriodPercent*3.6)/180*3.14159265)*78)" />
            </svg>
            <span v-if="expiryPeriodPercent">{{ expiryPeriodPercent }}<em>%</em></span>
            <span v-else>-</span>
          </div>
</template>

<script>
export default {
  props: ["expiryPeriodPercent", "width", "height"],
};
</script>
